@if ({ pkg: package$ | async, ctx: terminalBatchCtx$ | async }; as data) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: data }"
          ></ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ data: data, frm: mainFrm }"
          ></ng-template>
        </mat-toolbar>
      }
    </div>
    <!-- Content -->
    <div class="flex layout-col gap-md p-sm">
      <!-- Overview -->
      <div class="layout-row">
        <elder-card class="flex-100" [flat]="embedded">
          <elder-card-content>
            <form #mainFrm="ngForm" class="flex layout-col">
              <div class="layout-row gap-md pt-xs">
                <!-- Package Type -->
                <mat-form-field floatLabel="always">
                  <mat-label>{{ 'context.type' | translate }}</mat-label>
                  <mat-select
                    placeholder="{{ 'context.type' | translate }}"
                    [value]="data.pkg.typeId"
                    (selectionChange)="onPackageTypeChanged($event)"
                  >
                    @for (type of availablePackageTypes$ | async; track type) {
                      <mat-option [value]="type.id">
                        <div class="layout-row place-start-center gap-sm">
                          <span>{{ type.name }}</span>
                        </div>
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <!-- Weight -->
                <mat-form-field floatLabel="always">
                  <mat-label>{{ 'context.contentWeight' | translate }}</mat-label>
                  <mat-hint>{{
                    ('packages.packaging' | translate) +
                      ': ' +
                      ((data.pkg.packagingMaterialWeight | elderQuantity: true : null : '0.0-1') ||
                        '-')
                  }}</mat-hint>
                  <elder-quantity-input
                    name="contentWeight"
                    readonly
                    placeholder="-"
                    [displayFormat]="'0.0-1'"
                    [(ngModel)]="data.pkg.contentWeight"
                  >
                  </elder-quantity-input>
                </mat-form-field>
                <mat-form-field floatLabel="always">
                  <mat-label>{{ 'context.totalWeight' | translate }}</mat-label>
                  <mat-hint>{{
                    'Max: ' +
                      ((data.pkg.spec?.maxWeight | elderQuantity: true : null : '0.0-1') || '-')
                  }}</mat-hint>
                  <elder-quantity-input
                    name="weight"
                    readonly
                    placeholder="-"
                    [displayFormat]="'0.0-1'"
                    [ngModel]="data.pkg.weight"
                  >
                  </elder-quantity-input>
                </mat-form-field>
                <!-- Dimension -->
                <mat-form-field>
                  <mat-label>
                    {{ 'context.length' | translate }} x {{ 'context.width' | translate }} x
                    {{ 'context.height' | translate }}
                  </mat-label>
                  <elder-dimensions-input placeholder="-" [(ngModel)]="data.pkg.dimensions">
                  </elder-dimensions-input>
                  <mat-error elderValidationError></mat-error>
                </mat-form-field>
                <!-- Spacer -->
                <span class="flex"></span>
                <!-- Storage Location -->
                <mat-form-field elderFormFieldLabel class="pb-lg">
                  <mat-label>{{ 'shopfloor.storage.location' | translate }}</mat-label>
                  <input
                    matInput
                    name="storagePath"
                    readonly
                    placeholder="-"
                    [ngModel]="data.pkg.location?.storagePath"
                  />
                </mat-form-field>
              </div>
            </form>
          </elder-card-content>
        </elder-card>
      </div>
      <!-- Tabbed content -->
      <div class="flex layout-row">
        <elder-card class="flex-100" padding="0">
          <elder-card-content padding="0">
            <mat-tab-group class="flex" animationDuration="0">
              <!-- packaged items -->
              <mat-tab label="{{ 'packages.packagingGoods' | translate }}">
                <div class="full layout-row outlined">
                  <!-- work batch items-->
                  <div class="flex layout-col">
                    <elder-table
                      class="flex"
                      #batchItemsTable
                      matSort
                      denseHorizontal
                      [data]="batchItemData"
                      [idField]="'id'"
                      [interactionMode]="'selection'"
                      [selectionVisible]="!(viewMode$ | async)"
                      [selectionMultiEnabled]="true"
                      [selectableEvaluatorFn]="canAdd"
                      (selectionChange)="batchItemsSelection = $event"
                    >
                      <elder-data-toolbar
                        *elderTableToolbar
                        [canMore]="false"
                        [canAdd]="false"
                        [canRemove]="false"
                      >
                        <ng-template elderToolbarContent="left">
                          <span class="text-title-medium">
                            {{ 'workBatches.workBatchItems' | translate }}
                          </span>
                        </ng-template>
                        <ng-template elderToolbarContent="center">
                          <elder-search-box
                            dense
                            label="{{ 'positions.number' | translate }}"
                            placeholder="{{ 'positions.number' | translate }}"
                            elderKeyEvent
                            elderKeyEventFilter="Enter"
                            elderStopEventPropagation
                            (onElderKeyEvent)="onItemSearchEnter($event)"
                            queryKey="numbers"
                            [elderSearchContext]="batchItemData.filter"
                            [forcedFilters]="forcedFilter$ | async"
                          >
                          </elder-search-box>
                        </ng-template>
                      </elder-data-toolbar>
                      <!-- production priority Column -->
                      <ng-container matColumnDef="priority">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          class="cell-10"
                          mat-sort-header="{{ getSortByProcessingSequencePosString() }}"
                        >
                          {{ 'context.priority' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let item">{{ getProductionPriority(item) }}</td>
                      </ng-container>
                      <!-- number Column -->
                      <ng-container matColumnDef="number">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          elderNumberCell
                          style="width: 25%"
                          mat-sort-header
                        >
                          {{ 'positions.number' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let item" elderNumberCell>{{ item.number }}</td>
                      </ng-container>
                      <!-- mainProductQuantity Column -->
                      <ng-container matColumnDef="mainProductQuantity">
                        <th mat-header-cell *matHeaderCellDef elderNumberCell style="width: 25%">
                          {{ 'context.quantity' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let item" elderNumberCell>
                          {{ item.producedProduct | productSalesQuantity | elderQuantity }}
                        </td>
                      </ng-container>
                      <!-- totalWeight Column -->
                      <ng-container matColumnDef="totalWeight">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          elderNumberCell
                          style="width: 25%"
                          mat-sort-header="totalWeight.value"
                        >
                          {{ 'context.totalWeight' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let item" elderNumberCell>
                          {{ item.producedProduct | productSalesTotalWeight | elderQuantity }}
                        </td>
                      </ng-container>
                      <!-- actions -->
                      <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef style="width: 25%"></th>
                        <td mat-cell *matCellDef="let item; let i = index">
                          <button
                            mat-icon-button
                            elderStopEventPropagation
                            [name]="'addPartial' + i"
                            [disabled]="!canAdd(item) || !(canModifyPackages$ | async)"
                            (click)="addPartially(data.pkg, item)"
                          >
                            <mat-icon>chevron_right</mat-icon>
                          </button>
                          <button
                            mat-icon-button
                            elderStopEventPropagation
                            [name]="'addCompletely' + i"
                            [disabled]="!canAdd(item) || !(canModifyPackages$ | async)"
                            (click)="addCompletely(data.pkg, item)"
                          >
                            <mat-icon>last_page</mat-icon>
                          </button>
                        </td>
                      </ng-container>
                    </elder-table>
                  </div>
                  <mat-divider vertical></mat-divider>
                  <!-- transfer controls -->
                  <div class="layout-col place-center-center gap-xl" style="padding: 0 12px">
                    <button
                      mat-icon-button
                      [disabled]="
                        isEmpty(batchItemsSelection) ||
                        (viewMode$ | async) ||
                        !(canModifyPackages$ | async)
                      "
                      (click)="
                        addAllCompletely(data.pkg, batchItemsSelection);
                        batchItemsTable.selectionModel.clear()
                      "
                    >
                      <mat-icon class="rotate-90">arrow_circle_up</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      [disabled]="
                        isEmpty(packagedItemsSelection) ||
                        (viewMode$ | async) ||
                        !(canModifyPackages$ | async)
                      "
                      (click)="
                        removeFromPackage(data.pkg, packagedItemsSelection);
                        packageItemsTable.selectionModel.clear()
                      "
                    >
                      <mat-icon class="rotate-90">arrow_circle_down</mat-icon>
                    </button>
                  </div>
                  <mat-divider vertical></mat-divider>
                  <!-- package items -->
                  <div class="flex layout-col">
                    <elder-table
                      class="flex"
                      #packageItemsTable
                      matSort
                      denseHorizontal
                      [data]="data.pkg.items"
                      [idField]="'id'"
                      [interactionMode]="'selection'"
                      [selectionVisible]="!(viewMode$ | async)"
                      [selectionMultiEnabled]="true"
                      (selectionChange)="packagedItemsSelection = $event"
                      [selectableEvaluatorFn]="isOwnedByBatchEvaluator(terminalBatchCtx)"
                    >
                      <elder-data-toolbar
                        *elderTableToolbar
                        [canMore]="false"
                        [canAdd]="false"
                        [canRemove]="false"
                      >
                        <ng-template elderToolbarContent="left">
                          <div class="layout-row gap-md">
                            <span class="text-title-medium">
                              {{ 'packages.packagedItems' | translate }}
                            </span>
                          </div>
                        </ng-template>
                        <ng-template elderToolbarContent="right">
                          <button
                            mat-flat-button
                            color="primary"
                            [disabled]="!canClearPackageContent(data.pkg, data.ctx)"
                            (click)="clearPackageContent(data.pkg)"
                          >
                            {{ 'actions.removeAll' | translate }}
                          </button>
                        </ng-template>
                      </elder-data-toolbar>
                      <!-- number Column -->
                      <ng-container matColumnDef="itemNumber">
                        <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
                          {{ 'positions.number' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let pkgItem">{{ pkgItem.itemNumber }}</td>
                      </ng-container>
                      <!-- quantity Column -->
                      <ng-container matColumnDef="packagedQuantity">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          mat-sort-header="packagedQuantity.value"
                        >
                          {{ 'context.quantity' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let pkgItem">
                          {{ pkgItem.packagedQuantity | elderQuantity }}
                          / {{ pkgItem.totalQuantity | elderQuantity }}
                        </td>
                      </ng-container>
                      <!-- weight Column -->
                      <ng-container matColumnDef="weight">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="weight.value">
                          {{ 'context.weight' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let pkgItem">
                          {{ pkgItem.weight | elderQuantity }}
                        </td>
                      </ng-container>
                      <!-- hints Column -->
                      <ng-container matColumnDef="hints">
                        <th mat-header-cell *matHeaderCellDef>{{ 'context.hints' | translate }}</th>
                        <td mat-cell *matCellDef="let pkgItem">
                          <div class="layout-row place-start-center">
                            @if (pkgItem.partial) {
                              <mat-icon [matTooltip]="'context.subset' | translate"
                                >announcement
                              </mat-icon>
                            }
                          </div>
                        </td>
                      </ng-container>
                      <!-- share status Column -->
                      @if (packageSharingEnabled(terminalBatchCtx)) {
                        <ng-container matColumnDef="share">
                          <th mat-header-cell *matHeaderCellDef>
                            {{ 'packaging.batchPackageSharing.shared' | translate }}
                          </th>
                          <td mat-cell *matCellDef="let pkgItem">
                            <div class="layout-row place-start-center">
                              @if (isForeign(pkgItem, terminalBatchCtx)) {
                                <mat-icon
                                  [matTooltip]="'packaging.batchPackageSharing.shared' | translate"
                                >
                                  call_split
                                </mat-icon>
                              }
                            </div>
                          </td>
                        </ng-container>
                      }
                      <!-- actions -->
                      <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef style="width: 25%"></th>
                        <td mat-cell *matCellDef="let item">
                          <button
                            mat-icon-button
                            elderStopEventPropagation
                            [disabled]="
                              isForeign(item, terminalBatchCtx) ||
                              (viewMode$ | async) ||
                              !(canModifyPackages$ | async)
                            "
                            (click)="removeFromPackage(data.pkg, [item])"
                          >
                            <mat-icon>remove_circle_outline</mat-icon>
                          </button>
                        </td>
                      </ng-container>
                    </elder-table>
                  </div>
                </div>
              </mat-tab>
              <!-- packaging material -->
              <mat-tab
                label="{{ 'packages.packaging' | translate }}"
                [disabled]="!allowPackagingEdit()"
              >
                <div class="layout-col">
                  <app-packaging-material-table
                    class="flex"
                    [packagingItems]="data.pkg.packagingItems"
                    [packagingMaterialSpecs]="data.pkg.type.supportedPackagingMaterials"
                    (packagingItemsChange)="onPackagingItemsChange($event)"
                  >
                  </app-packaging-material-table>
                </div>
              </mat-tab>
            </mat-tab-group>
          </elder-card-content>
        </elder-card>
      </div>
    </div>
  </div>
}

<ng-template #header let-data="data" let-frm="frm">
  <div class="flex layout-row gap-md place-start-center">
    @if (creationMode$ | async) {
      <span>
        {{ 'packages.new' | translate }}
      </span>
    } @else {
      <elder-header
        [header]="('packages.package' | translate) + ' ' + data.pkg.number"
        [subheader]="('orders.work.order' | translate) + ' ' + data.pkg.workOrderId"
      >
      </elder-header>
    }

    <span class="flex"></span>
    <!-- todo: fix vertical placing-->
    <app-print-button
      appPrintCommand
      [reportSpec]="labelReport$ | async"
      [printerId]="data.ctx.terminal.labelPrinter?.printerId"
    >
    </app-print-button>

    <button
      mat-icon-button
      [disabled]="!frm.form.valid || (viewMode$ | async)"
      (click)="onSave($event)"
    >
      <mat-icon>save</mat-icon>
    </button>

    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <button
        mat-menu-item
        [disabled]="!canPreviewPackageLabel(data.ctx)"
        (click)="onPreviewPackageLabel(data.pkg)"
      >
        <mat-icon>preview</mat-icon>
        <span>{{ 'labels.preview' | translate }}</span>
      </button>

      @let canDelete = canDelete$ | async;
      @let deletionDisabled = !canDelete;
      <button mat-menu-item (click)="onDelete($event)" [disabled]="deletionDisabled">
        <mat-icon>delete</mat-icon>
        <span>{{ 'actions.delete' | translate }}</span>
      </button>
    </mat-menu>
  </div>
</ng-template>
